const content: { [key: string]: any } = {
  monthlyTarget: "Desired Target",
  onTrack: "On Track",
  belowTarget: "Below Desired Target",
  accessibility: {
    legendExempt: "Chart legend: You are exempt from this requirement.",
    legendActive: "Chart legend: Progress indicators for monthly targets",
    legendItem: "{item} indicator",
  },
};

export default content;
